import { Component, OnInit } from '@angular/core'
import { Store, select } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { LanguageService } from '../language.service'
import { Language } from '../store/i18n.interface'
import { getAvaliableLanguagesState } from '../store/i18n.selector'

@Component({
  selector: 'app-select-language',
  templateUrl: './select-language.component.html',
  styleUrls: ['./select-language.component.scss'],
})
export class SelectLanguageComponent implements OnInit {
  languages$: Observable<Array<Language>>
  isLanguagesOpen = false

  constructor(
    private store: Store<any>,
    public translateService: TranslateService,
    public languageService: LanguageService,
  ) {
    this.languages$ = this.store.pipe(
      select(getAvaliableLanguagesState),
      filter((state) => Boolean(state)),
      map((state) => state.toJS()),
    )
  }
  ngOnInit() {}

  saveLang() {}
}
